import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./ClientHasAYetToShippedOrder.css";
import { actionOrderToCheckIfThereIsApendingOrder } from "../../actions/orderActions";
import { ORDER_IS_PENDING_RESET } from "../../constants/orderConstants";

export default function ClientHasAYetToShippedOrder(props) {
  const dispatch = useDispatch();
  const location = useLocation();

  // PROPS COMING FROM App
  const { orderId } = props;

  // REDUX STATE THAT HOLDS INFO IF THERE IS A PENDING ORDER OF CLIENT
  const checkIfThereIsApendingOrder = useSelector(
    (state) => state.checkIfThereIsApendingOrder,
  );
  const { loading, error, isPending } = checkIfThereIsApendingOrder;

  // BRING IN ORDERS MADE BY CLIENT
  useEffect(() => {
    if (orderId) {
      dispatch(actionOrderToCheckIfThereIsApendingOrder(orderId));
    }
  }, [dispatch, orderId, location]);

  // RESET WHEN NO PENDING ORDER
  useEffect(() => {
    if (isPending && isPending.isTherePending === "NO") {
      setTimeout(() => {
        localStorage.removeItem("tChAo");
        dispatch({ type: ORDER_IS_PENDING_RESET });
      }, 2000);
    }
  }, [dispatch, isPending]);

  return (
    <>
      {loading
        ? ""
        : error
          ? ""
          : isPending &&
            isPending.isTherePending === "YES" &&
            !location.pathname.includes("admin") && (
              <div className="clienthasayettoshippedorder">
                <div className="clienthasayettoshippedorder-inner">
                  <div className="clienthasayettoshippedorder-badge">
                    İndirimli
                    <br />
                    Ek Sipariş
                  </div>

                  <div className="clienthasayettoshippedorder-content">
                    <div className="clienthasayettoshippedorder-title">
                      Ek sipariş indiriminiz devam ediyor
                    </div>

                    <ul className="clienthasayettoshippedorder-list">
                      <li>
                        <i className="fas fa-circle"></i>
                        <span>
                          Siparişiniz paketlenene kadar indirimli ek sipariş
                          oluşturabilirsiniz.
                        </span>
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>
                        <span>
                          Ek siparişleriniz mevcut siparişinizle birlikte
                          paketlenir.
                        </span>
                      </li>
                      <li>
                        <i className="fas fa-circle"></i>
                        <span>
                          Paketleme gün içinde yapılır. Paketleme tamamlanınca
                          bu indirim sona erer.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}
    </>
  );
}
